import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Modal: shows list of participants for one status (Katılıyorum / Belki / Katılmıyorum).
 * Only user name + profile photo (avatar). No other info.
 */
const EventParticipantsModal = ({ isOpen, onClose, participants = [], filterStatus, title }) => {
  const { t } = useTranslation('chat');
  if (!isOpen) return null;

  const list = participants.filter((p) => p.status === filterStatus);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100001] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
            className="relative bg-[var(--color-bg-base)] dark:bg-[var(--color-bg-elevated)] rounded-xl shadow-xl border border-white/10 dark:border-white/10 max-w-sm w-full max-h-[70vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-white/10 dark:border-white/10">
              <h3 className="text-lg font-semibold text-[var(--color-text-primary)] dark:text-white">{title}</h3>
              <button
                type="button"
                onClick={onClose}
                className="p-1 rounded-full text-[var(--color-text-muted)] hover:bg-[var(--color-bg-elevated)] dark:hover:bg-[#24354f] hover:text-[var(--color-text-secondary)] dark:hover:text-white transition-colors"
                aria-label={t('common:close')}
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <ul className="p-4 overflow-y-auto space-y-2">
              {list.length === 0 ? (
                <li className="text-sm text-[var(--color-text-muted)] dark:text-[var(--color-text-muted)]">{t('eventParticipants.noOne')}</li>
              ) : (
                list.map((p) => (
                  <li key={p.user_id} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#24354f] dark:bg-[#24354f] overflow-hidden flex items-center justify-center text-sm font-medium text-[var(--color-text-secondary)] dark:text-gray-300">
                      {p.avatar_url ? (
                        <img src={p.avatar_url} alt="" className="w-full h-full object-cover" />
                      ) : (
                        (p.name || '?').charAt(0).toUpperCase()
                      )}
                    </div>
                    <span className="font-medium text-[var(--color-text-primary)] dark:text-white truncate">{p.name || t('unknownUser')}</span>
                  </li>
                ))
              )}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EventParticipantsModal;
